import { render, staticRenderFns } from "./RegistroCapacitaciones_agregar.vue?vue&type=template&id=244fa6b6&scoped=true"
import script from "./RegistroCapacitaciones_agregar.vue?vue&type=script&lang=js"
export * from "./RegistroCapacitaciones_agregar.vue?vue&type=script&lang=js"
import style0 from "./RegistroCapacitaciones_agregar.vue?vue&type=style&index=0&id=244fa6b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244fa6b6",
  null
  
)

export default component.exports